import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';

@Component({
  selector: 'gn-radio',
  template: `
    <nz-radio-group [(ngModel)]="value" (ngModelChange)="valueChanged.emit()">
      <label nz-radio *ngFor="let item of items" [nzValue]="item.value">{{item.label}}</label>
    </nz-radio-group>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnRadioComponent),
    multi: true
  }]
})
@GnFormItem('radio')
export class GnRadioComponent implements ControlValueAccessor {

  private innerValue: any;

  @Input() set value(v: any) {
    if (this.innerValue !== v) {
      this.innerValue = v;
      this.valueChange(this.innerValue);
    }
  }

  get value(): any {
    return this.innerValue;
  }

  @Input() items: { value: any, label: string }[] = [];
  @Output() valueChanged = new EventEmitter();

  valueChange = (value: any) => {
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
